import React from 'react';
import PropTypes from 'prop-types';

import { SearchTableFilter } from 'common/components/svgs';

const FilterIcon = ({ color }) => <SearchTableFilter width={12} height={12} fill={color} />;

FilterIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default FilterIcon;
